/**
 * Viewport Observer — Sonar-friendly (functions < 15 cognitive complexity)
 * - .e-stn--observe: threshold 0.1, bottom margin -10%
 * - .e-ctr: trigger when element reaches bottom 1% of viewport
 */

( function init() {
  if ( !supportsIO() ) {
    initFallback();
    return;
  }

  const markInViewport = ( entries ) => {
    for ( const e of entries ) if ( e.isIntersecting ) e.target.classList.add( 'in-viewport' );
  };

  const standardObserver = createObserver( markInViewport, '0px 0px -10% 0px', 0.1 );
  const ctrObserver = createObserver( markInViewport, '0px 0px 1% 0px', 1 );

  observeAll( standardObserver, '.e-stn--observe' );
  observeAll( ctrObserver, '.e-ctr' );
} )();

// Keep your original immediate fire behavior
if ( document.readyState !== 'loading' ) {
  document.dispatchEvent( new Event( 'DOMContentLoaded' ) );
}

/* =========================
 * Small, focused helpers
 * ========================= */

function supportsIO() {
  return 'IntersectionObserver' in window;
}

function createObserver( callback, rootMargin, threshold ) {
  return new IntersectionObserver( callback, {
    root: null,
    rootMargin,
    threshold
  } );
}

function observeAll( observer, selector ) {
  const nodes = document.querySelectorAll( selector );
  for ( const n of nodes ) observer.observe( n );
}

/* ========= Fallback (no IO) ========= */

function initFallback() {
  const SELECT_STANDARD = '.e-stn--observe';
  const SELECT_CTR = '.e-ctr';
  const nodes = document.querySelectorAll( `${SELECT_STANDARD}, ${SELECT_CTR}` );

  const isStandardHit = ( rect, vh ) => rect.top < vh * 0.9 && rect.bottom > 0;
  const isCtrHit = ( rect, vh ) => rect.bottom <= vh * 0.999 && rect.bottom > 0;

  const handler = makeFallbackHandler( nodes, isStandardHit, isCtrHit );
  window.addEventListener( 'scroll', handler, { passive: true } );
  window.addEventListener( 'resize', handler, { passive: true } );
  handler(); // initial check
}

function makeFallbackHandler( nodes, isStandardHit, isCtrHit ) {
  return function checkViewport() {
    const vh = window.innerHeight;
    for ( const el of nodes ) {
      if ( el.classList.contains( 'in-viewport' ) ) continue;

      const rect = el.getBoundingClientRect();
      const hit = el.classList.contains( 'e-ctr' )
        ? isCtrHit( rect, vh )
        : isStandardHit( rect, vh );

      if ( hit ) el.classList.add( 'in-viewport' );
    }
  };
}
